// extracted by mini-css-extract-plugin
export default {"container":"LayoutNew_container__-oyGX","sub_container":"LayoutNew_sub_container__4hRJR"};